export enum DISCOVERY_JAPAN_CATEGORY {
	FOOD = 'Eat like a local',
	ANIME = 'Experience anime and become an otaku',
	CULTURE = 'Tradition and Culture',
	WORKSHOP = 'Classes and Workshops',
	NATURE = 'Nature and Wellness',
}

export enum DISCOVERY_TAG_GROUP_ID {
	CULTURE = '2791',
	FOOD = '2803',
	NATURE = '2805',
	ANIME = '2786',
	WORKSHOP = '2801',
	PEASY_FEATURED = '5502',
}